/* Sticky add-to-cart bar.
   ES2019 only (FB/IG in-app WebViews) — no optional chaining, no nullish
   coalescing, no class fields.

   The bar never owns the selection. The main variant picker
   (variant-radios / variant-selects) stays the single source of truth: a tap
   here checks the corresponding control in that picker and dispatches a
   native change, so price, media, URL, availability and the main form's
   variant input all update through the theme's own code path. The bar then
   re-renders from whatever the picker settled on. That is what makes the two
   agree in both directions instead of drifting apart, which is exactly what
   the old flattened <select> did — it wrote a hidden input and told the main
   picker nothing.

   Nothing is ever auto-switched. Sold-out combinations render struck through
   and non-interactive, so a tap cannot quietly relocate the customer to a
   neighbouring variant. */

(function () {
  var bar = document.querySelector('.product__sticky');
  if (!bar) return;

  var variantsTag = bar.querySelector('[data-sticky-variants]');
  var labelsTag = bar.querySelector('[data-sticky-labels]');
  if (!variantsTag || !labelsTag) return;

  var variants, labels;
  try {
    variants = JSON.parse(variantsTag.textContent);
    labels = JSON.parse(labelsTag.textContent);
  } catch (e) {
    return;
  }

  var picker = document.querySelector('variant-radios, variant-selects');
  var idInput = bar.querySelector('#sticky__selected_variant_id');
  var submit = bar.querySelector('[data-sticky-submit]');
  var trigger = bar.querySelector('[data-sticky-colour-trigger]');
  var pop = bar.querySelector('[data-sticky-colour-pop]');
  var colourPos = labels.colourPosition;

  /* Read the selection out of the picker rather than keeping our own copy —
     it is authoritative and can also change from the size finder, a ?variant=
     deep link, or the customer using the main controls. */
  function readSelection() {
    if (!picker) return null;
    var groups = picker.querySelectorAll('fieldset');
    var values = [];
    var i;
    if (groups.length) {
      for (i = 0; i < groups.length; i++) {
        var checked = groups[i].querySelector('input[type="radio"]:checked');
        values.push(checked ? checked.value : null);
      }
      return values;
    }
    var selects = picker.querySelectorAll('select');
    for (i = 0; i < selects.length; i++) values.push(selects[i].value);
    return values.length ? values : null;
  }

  function sameOptions(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  function findVariant(options) {
    for (var i = 0; i < variants.length; i++) {
      if (sameOptions(variants[i].options, options)) return variants[i];
    }
    return null;
  }

  /* Availability of the combination you would land on by changing exactly one
     option — the honest question for a chip or a swatch. */
  function variantIfChanged(current, position, value) {
    if (!current) return null;
    var candidate = current.slice();
    candidate[position - 1] = value;
    return findVariant(candidate);
  }

  function setChecked(el, checked) {
    el.setAttribute('aria-checked', checked ? 'true' : 'false');
  }

  function setDisabled(el, disabled) {
    if (disabled) el.setAttribute('aria-disabled', 'true');
    else el.removeAttribute('aria-disabled');
  }

  function render() {
    var current = readSelection();
    if (!current) return;
    var variant = findVariant(current);
    var i;

    var groups = bar.querySelectorAll('[data-sticky-chip-group]');
    for (var g = 0; g < groups.length; g++) {
      var pos = parseInt(groups[g].getAttribute('data-option-position'), 10);
      var chips = groups[g].querySelectorAll('[data-sticky-chip-value]');
      for (i = 0; i < chips.length; i++) {
        var val = chips[i].getAttribute('data-sticky-chip-value');
        var cand = variantIfChanged(current, pos, val);
        var isSelected = current[pos - 1] === val;
        setChecked(chips[i], isSelected);
        /* Only options you could move TO are struck. The current choice stays
           legible even when it is sold out — the button reports that. */
        setDisabled(chips[i], !isSelected && (!cand || !cand.available));
      }
    }

    if (colourPos && pop) {
      var swatches = pop.querySelectorAll('[data-sticky-colour-value]');
      for (i = 0; i < swatches.length; i++) {
        var cval = swatches[i].getAttribute('data-sticky-colour-value');
        /* Each swatch carries its own option position: the bundles expose two
           colour options, and using the trigger's position for all of them
           would test the wrong option for availability and select the wrong
           one on tap. */
        var cpos = parseInt(swatches[i].getAttribute('data-option-position'), 10);
        if (isNaN(cpos)) cpos = colourPos;
        var ccand = variantIfChanged(current, cpos, cval);
        var cSelected = current[cpos - 1] === cval;
        setChecked(swatches[i], cSelected);
        setDisabled(swatches[i], !cSelected && (!ccand || !ccand.available));
        /* Only the primary colour option drives the trigger's label/thumb. */
        if (cSelected && cpos === colourPos && trigger) {
          var nameEl = trigger.querySelector('[data-sticky-colour-name]');
          var thumbEl = trigger.querySelector('[data-sticky-colour-thumb]');
          /* The resolved CSS colour, carried on the swatch by Liquid. Was
             copying an <img> src, which is what put a cropped model photo in
             the trigger; the thumb is a background-painted span now. Empty
             means this value has no swatch, so the disc is hidden rather than
             left blank — an empty circle reads as a failed image. */
          var cswatch = swatches[i].getAttribute('data-swatch');
          if (nameEl) nameEl.textContent = cval;
          if (thumbEl) {
            if (cswatch) {
              thumbEl.style.background = cswatch;
              thumbEl.style.backgroundSize = 'cover';
              thumbEl.hidden = false;
            } else {
              thumbEl.hidden = true;
            }
          }
        }
      }
    }

    if (idInput && variant) idInput.value = variant.id;

    if (submit) {
      var available = !!(variant && variant.available);
      submit.disabled = !available;
      while (submit.firstChild) submit.removeChild(submit.firstChild);
      if (available) {
        /* The add_to_cart translation ships with a trailing space. */
        submit.appendChild(document.createTextNode(String(labels.addToCart).trim() + ' '));
        var span = document.createElement('span');
        span.className = 'sticky-atc__price';
        span.setAttribute('data-sticky-price', '');
        span.textContent = '· ' + variant.price;
        submit.appendChild(span);
      } else {
        submit.appendChild(document.createTextNode(labels.soldOut));
      }
    }
  }

  /* Drive the real picker. Setting .checked alone does not notify it — the
     change event is what runs its onVariantChange. */
  function select(position, value) {
    if (!picker) return;
    var groups = picker.querySelectorAll('fieldset');
    var i;
    if (groups.length && groups[position - 1]) {
      var inputs = groups[position - 1].querySelectorAll('input[type="radio"]');
      for (i = 0; i < inputs.length; i++) {
        if (inputs[i].value === value) {
          if (inputs[i].checked) return;
          inputs[i].checked = true;
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
      return;
    }
    var selects = picker.querySelectorAll('select');
    if (selects[position - 1]) {
      if (selects[position - 1].value === value) return;
      selects[position - 1].value = value;
      selects[position - 1].dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function closePop() {
    if (!pop || !trigger) return;
    pop.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }

  bar.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var chip = event.target.closest('[data-sticky-chip-value]');
    if (chip && !chip.hasAttribute('aria-disabled')) {
      var group = chip.closest('[data-sticky-chip-group]');
      if (group) {
        select(parseInt(group.getAttribute('data-option-position'), 10), chip.getAttribute('data-sticky-chip-value'));
      }
      return;
    }

    var swatch = event.target.closest('[data-sticky-colour-value]');
    if (swatch && !swatch.hasAttribute('aria-disabled')) {
      var spos = parseInt(swatch.getAttribute('data-option-position'), 10);
      if (isNaN(spos)) spos = colourPos;
      select(spos, swatch.getAttribute('data-sticky-colour-value'));
      /* Multi-colour products keep the popover open so the customer can set
         both pieces without reopening it; single-colour products close, which
         is the old behaviour. */
      if (bar.querySelectorAll('.sticky-colour__group').length < 2) closePop();
      return;
    }

    if (trigger && pop && event.target.closest('[data-sticky-colour-trigger]')) {
      var willOpen = pop.hidden;
      pop.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }
  });

  document.addEventListener('click', function (event) {
    if (!pop || pop.hidden) return;
    if (event.target.closest && event.target.closest('.product__sticky')) return;
    closePop();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePop();
  });

  /* Main picker -> bar. setTimeout 0 so we read the picker AFTER its own
     change handler has recomputed currentVariant and repainted its controls. */
  if (picker) {
    picker.addEventListener('change', function () {
      window.setTimeout(render, 0);
    });
  }

  render();
})();

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () {
    stickyScroll();
  });
  document.addEventListener('shopify:section:select', function () {
    stickyScroll();
  });
  document.addEventListener('shopify:section:deselect', function () {
    stickyScroll();
  });
}

const stickyScroll = () => {
  const BuyButtonForm = document.querySelector('.product_buy_button_form');
  const productStickyWrapper = document.querySelector('.product__sticky');
  if (!BuyButtonForm || !productStickyWrapper) return;

  window.addEventListener('scroll', function () {
    let BuyBUttonOffset = TopOffset(BuyButtonForm);
    let BuyBUttonTopffset = BuyBUttonOffset.top;

    if (window.scrollY > BuyBUttonTopffset) {
      productStickyWrapper.classList.add('sticky');
      document.body.classList.add('sticky__cart');
    } else {
      productStickyWrapper.classList.remove('sticky');
      document.body.classList.remove('sticky__cart');
    }
  });
};
stickyScroll();
